// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"581":"88b1b2fd","3933":"17e437da","3964":"95220404","6215":"a73fba42","6662":"e02eae2a"}[chunkId] + ".chunk.css";
};